<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb
      :crumbs="[{ 'path': 'webhooks', 'name': 'Webhooks'}, { 'name': `${webhook.id}`}]"
    />
    <a-tabs defaultActiveKey="1" :size="size">
      <a-tab-pane tab="General" key="1">
        <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
          <a-form :layout="formLayout" :form="form" style="margin-top:1em;">
            <a-url-field
              varName="url"
              varLabel="Webhook URL"
              :varRequired="true"
              :formLayout="formLayout"
              :size="size"
              :varInitial="webhook.url"
              icon="link"
            />
            <a-select-field
              :formLayout="formLayout"
              :size="size"
              varName="event"
              varLabel="Event Type"
              :varRequired="true"
              type="schema"
              :varOptions="Events"
              :varInitial="webhook.event"
              :disabled="true"
              description="Event type to trigger the webhook"
            />
            <a-text-field
            varName="hmac_digest"
            varLabel="Digest Method"
            :varRequired="true"
            :varInitial="webhook.hmac_digest"
            :formLayout="formLayout"
            :size="size"
            :disabled="true"
            />
            <a-text-clipboard-field
              v-if="webhook.hmac_secret"
              varName="hmac_secret"
              varLabel="Digest Secret"
              :varRequired="true"
              :varInitial="webhook.hmac_secret"
              :formLayout="formLayout"
              :size="size"
              :disabled="true"
              :value="webhook.hmac_secret"
              varType="password"
            />
            <a-form-item
              :wrapper-col="buttonItemLayout.wrapperCol"
              style="margin-top:0.5em;padding-left:4em;"
            >
              <a-button
                type="primary"
                shape="round"
                size="large"
                @click="handleSubmit"
              >Update Details</a-button>
              <a-popconfirm
                v-if="!loading"
                placement="left"
                okText="Yes"
                cancelText="No"
                style="margin-left: 30px; float: right;"
                @confirm="handleDelete"
              >
                <p slot="title" style="font-size:14px;">Do you want to delete this webhook？</p>
                <a-icon slot="icon" type="question-circle-o" style="color: red" />
                <a-button type="danger" size="large">Delete webhook</a-button>
              </a-popconfirm>
            </a-form-item>
          </a-form>
        </a-skeleton>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";
import Events from "@/configs/WebhookEvents.js";

export default {
  data() {
    return {
      loading: true,
      size: "large",
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      Events
    };
  },
  methods: {
    async handleDelete() {
      try {
        await this.$store.dispatch("tenant/deleteItem", {
          endpoint: "webhooks",
          uuid: this.$route.params.uuid
        });
        await this.$router.push("/webhooks");
        await this.$notification.open({
          message: "Webhook delete!",
          description: "Webhook was deleted.",
          icon: (
            <a-icon type="check-circle" theme="filled" style="color: green" />
          )
        });
      } catch (error) {
        console.error(error);
      }
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await this.$store.dispatch("tenant/patchItem", {
              endpoint: "webhooks",
              uuid: this.$route.params.uuid,
              data: values
            });
            await this.$notification.open({
              message: "Updated!",
              description: "Webhook settings updated",
              icon: (
                <a-icon
                  type="check-circle"
                  theme="filled"
                  style="color: green"
                />
              )
            });
          } catch (error) {
            console.error(error);
            let errorConfig = {};
            if (error.response.data.hasOwnProperty("url")) {
              errorConfig["url"] = {
                value: values.url,
                errors: [new Error(`${error.response.data.url}`)]
              };
            }
            if (error.response.data.hasOwnProperty("event")) {
              errorConfig["event"] = {
                value: values.event,
                errors: [new Error(`${error.response.data.event}`)]
              };
            }
            form.setFields(errorConfig);
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  },

  mixins: [formLayoutMixin],

  computed: {
    webhook() {
      return this.$store.state.tenant.webhooks_item
        ? this.$store.state.tenant.webhooks_item
        : {};
    }
  },

  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItem", {
        endpoint: "webhooks",
        uuid: this.$route.params.uuid
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>